import { valueTypes } from "utils/builder/ResultClasses";

/**
 * Checks if the type is a text or number input type
 * @param {number} type - The value type to check
 * @returns {boolean}
 */
export const isTextOrNumberType = (type) => {
  return [
    valueTypes.customNumber,
    valueTypes.customLink,
    valueTypes.customText,
    valueTypes.proText,
    valueTypes.proNumber,
    valueTypes.proLink,
  ].includes(type);
};

/**
 * Checks if the type is a boolean type
 * @param {number} type - The value type to check
 * @returns {boolean}
 */
export const isBoolType = (type) => {
  return [valueTypes.customBool, valueTypes.proBool].includes(type);
};

/**
 * Checks if the type is a date type
 * @param {number} type - The value type to check
 * @returns {boolean}
 */
export const isDateType = (type) => {
  return [valueTypes.customDate, valueTypes.proDate].includes(type);
};

/**
 * Checks if the type is an enum (single or multi choice) type
 * @param {number} type - The value type to check
 * @returns {boolean}
 */
export const isEnumType = (type) => {
  return [
    valueTypes.customEnumSingle,
    valueTypes.customEnumMulty,
    valueTypes.proEnumSingle,
    valueTypes.proEnumMulty,
  ].includes(type);
};

/**
 * Checks if the type is a multi-choice enum type
 * @param {number} type - The value type to check
 * @returns {boolean}
 */
export const isMultiEnumType = (type) => {
  return [valueTypes.customEnumMulty, valueTypes.proEnumMulty].includes(type);
};

/**
 * Checks if the type is a single-choice enum type
 * @param {number} type - The value type to check
 * @returns {boolean}
 */
export const isSingleEnumType = (type) => {
  return [valueTypes.customEnumSingle, valueTypes.proEnumSingle].includes(type);
};

/**
 * Checks if the type is a number type (custom or pro)
 * @param {number} type - The value type to check
 * @returns {boolean}
 */
export const isNumberType = (type) => {
  return [valueTypes.customNumber, valueTypes.proNumber].includes(type);
};

/**
 * Common ReactSelect styles for modals
 * Ensures dropdown menu appears above modals and has consistent styling
 */
export const getReactSelectStyles = () => ({
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  control: (baseStyles) => ({
    ...baseStyles,
    borderColor: '#797D93',
  }),
});

/**
 * Boolean options for ReactSelect
 */
export const booleanOprions = [
  { label: "true", value: true },
  { label: "false", value: false },
];

